import { i18n } from "@lingui/core";
import { WIcon } from "@warp-ds/components/react/icon";
import React from "react";
import type { ImageSizes, ImageSourceOptions } from "../../../common/lib/image-source";

const BASE_CDN_URL = "https://images.finncdn.no/dynamic";

const DEFAULT_RESOLUTION = 480;

const FALLBACK_IMAGE = ({ className = "" }: { className?: string }) => (
	<picture className={`${className} grid s-bg-subtle`}>
		<WIcon
			name="Mountain"
			size="64px"
			className="m-auto s-icon-subtle"
			role="img"
			locale={i18n.locale}
			aria-label={i18n.t({
				id: "search.ad.fallback-image-alt",
				message: "Two mountains and a cloud",
			})}
		/>
	</picture>
);

// See
// https://github.schibsted.io/finn/yams-rules/blob/master/src/main/groovy/no/finntech/image/rules/RuleBuilder.groovy
// for available sizes
const IMAGE_SIZES: ImageSizes = [
	[240, "240w"],
	[320, "320w"],
	[480, "480w"],
	[640, "640w"],
	[960, "960w"],
];

type AdImageOptions = ImageSourceOptions & {
	fallbackImage: FallbackImageProp;
};

type FallbackImageProp = (args: { className?: string }) => React.ReactElement | null;

const AdImageOptions = React.createContext<AdImageOptions>({
	baseCdnUrl: BASE_CDN_URL,
	defaultResolution: DEFAULT_RESOLUTION,
	fallbackImage: FALLBACK_IMAGE,
	imageSizes: IMAGE_SIZES,
});

export function useAdImageOptions() {
	const context = React.useContext(AdImageOptions);
	return context;
}
